<ng-container>
	<mat-card (cdkDragEnded)="_dragEnd($event);"
			  (mousedown)="_mouseDown($event);"
			  [cdkDragFreeDragPosition]="position"
			  [ngStyle]="_visible()"
			  cdkDrag
			  cdkDragBoundary=".desktop"
			  class="drag-box shot-list panel">

		<div *ngIf="!locked" [ngClass]="{'active-panel-tab': _active(), 'panel-tab': !_active()}" fxLayout="row">
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button (click)="_visibleChange(false);" class="close-button" color="primary" mat-icon-button id="mat-clear-button">
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex>{{title}}</div>
		</div>

		<mat-card style="padding:0">
			<div *ngIf="locked" cdkDragHandle></div>
			<div style="padding:12px;height: 800px;">

				<div #selectedList="cdkDropList"
					 (cdkDropListDropped)="onDropSelect($event, false)"
					 [cdkDropListConnectedTo]="[allList]"
					 [cdkDropListData]="selected"
					 cdkDropList
					 cdkDropListSortingDisabled
					 displayed
					 style="height:200px;overflow: scroll;box-shadow: 4px 4px 6px 4px #00000030 inset;">
					<div *ngFor="let shot of selected" [matTooltip]="message(shot) | truncate:40" [style.background]="clubNumber(shot) | clubcolor: false" cdkDrag cdkDragDisabled="true" class="select-box select" fxLayout="row" fxLayoutAlign="space-between center" matRipple matTooltipPosition="right" style="font-size:10px;font-weight:500;">
						<div fxFlex="8">
							<mat-checkbox (change)="onCheck(shot)" checked="shot.isSelected"></mat-checkbox>
						</div>
						<div fxFlex="12">
							<button (click)="setLike(shot)" mat-icon-button id="mat-like-button">
								<mat-icon *ngIf="getLike(shot)" class="material-icons" style="color: #ffd500;">star</mat-icon>
								<mat-icon *ngIf="!getLike(shot)" class="material-icons" style="color: #b9b9b9;">star</mat-icon>
							</button>
						</div>

						<div fxFlex="10">
							<div [ngStyle]="clubBorderStyle(shot)">
								<div [ngStyle]="clubFontStyle(shot)">
									{{clubName(shot)}}
								</div>
							</div>
						</div>
						<div fxFlex="14">
							<div [ngStyle]="scoreStyle(shot)" style="font-weight:900;font-size: 16px;">{{score(shot)}}</div>
						</div>
						<div fxFlex="36">
							<div *ngIf="hasPrizm(shot)" style="color:#009005;">{{realname(shot) | truncate:20}}</div>
							<div *ngIf="!hasPrizm(shot)" style="color:#b00101;">{{realname(shot) | truncate:20}}</div>
							<div>{{nickname(shot) | truncate:20}}</div>
						</div>
						<div fxFlex="10">
							<button (click)="onUpdateShot(shot)" color="primary" mat-icon-button id="mat-edit-button">
								<ng-content *ngIf="isPublic(shot); then _public; else _private"></ng-content>
								<ng-template #_public>
									<mat-icon class="material-icons" color="primary">edit</mat-icon>
								</ng-template>
								<ng-template #_private>
									<mat-icon class="material-icons">edit</mat-icon>
								</ng-template>
							</button>
						</div>
						<div fxFlex="10">
							<button (click)="onDeselect(shot)" color="warn" mat-icon-button id="mat-cancel-button">
								<mat-icon class="material-icons">cancel</mat-icon>
							</button>
						</div>

					</div>
				</div>

				<div fxLayout="column">

					<button (click)="prev()" [disabled]="!hasPrev() || isProgress" color="primary" mat-raised-button id="mat-prev-button">
						<mat-icon>arrow_drop_up</mat-icon>
					</button>
					<div #allList="cdkDropList"
						 (cdkDropListDropped)="onDropSelect($event, true)"
						 [cdkDropListConnectedTo]="[selectedList]"
						 [cdkDropListData]="_shots"
						 [cdkDropListDisabled]="this.selected.length >= 20"
						 cdkDropList
						 cdkDropListLockAxis="y"
						 cdkDropListSortingDisabled
						 style="min-height:460px;max-height:100%;">
						<div *ngFor="let shot of _shots" [cdkDragDisabled]="isSelected(shot)" [matTooltip]="message(shot) | truncate:40" [style.background]="clubNumber(shot) | clubcolor:isSelected(shot)" cdkDrag class="select-box" fxLayout="row" fxLayoutAlign="space-between center" matRipple matTooltipPosition="right" style="font-size:10px;font-weight:500;">
							<div fxFlex="8">

							</div>
							<div fxFlex="12">
								<button (click)="setLike(shot)" mat-icon-button id="mat-like-button">
									<mat-icon *ngIf="getLike(shot)" class="material-icons" style="color: #ffd500;">star</mat-icon>
									<mat-icon *ngIf="!getLike(shot)" class="material-icons" style="color: #b9b9b9;">star</mat-icon>
								</button>
							</div>
							<div fxFlex="10">
								<div [ngStyle]="clubBorderStyle(shot)">
									<div [ngStyle]="clubFontStyle(shot)">
										{{clubName(shot)}}
									</div>
								</div>
							</div>
							<div fxFlex="14">
								<div [ngStyle]="scoreStyle(shot)" style="font-weight:900;font-size: 16px;">{{score(shot)}}</div>
							</div>
							<div fxFlex="36">
								<div *ngIf="hasPrizm(shot)" style="color:#6dd601;">{{realname(shot) | truncate:20}}</div>
								<div *ngIf="!hasPrizm(shot)" style="color:#b00101;">{{realname(shot) | truncate:20}}</div>
								<div>{{nickname(shot) | truncate:20}}</div>
							</div>
							<div fxFlex="10">
								<button (click)="onUpdateShot(shot)" [disabled]="isProgress" color="primary" mat-icon-button id="mat-shot-button">
									<ng-content *ngIf="isPublic(shot); then _public; else _private"></ng-content>
									<ng-template #_public>
										<mat-icon class="material-icons" color="primary">edit</mat-icon>
									</ng-template>
									<ng-template #_private>
										<mat-icon class="material-icons">edit</mat-icon>
									</ng-template>
								</button>
							</div>
							<div fxFlex="10">
								<button (click)="onDeleteShot($event, shot._id)" [disabled]="isProgress || !own(shot) || isSelected(shot)" color="warn" mat-icon-button id="mat-sweep-button">
									<mat-icon class="material-icons">delete_sweep</mat-icon>
								</button>
							</div>
						</div>
					</div>
					<button (click)="next()" [disabled]="!hasNext() || isProgress" color="primary" mat-raised-button id="mat-next-button">
						<mat-icon>arrow_drop_down</mat-icon>
					</button>
				</div>
			</div>
		</mat-card>

		<div [@sorter_slide]="sorter_slide_position" fxLayout="row" style="position: absolute;top:15px;z-index:-1; backdrop-filter: blur(12px);">
			<mat-card style="width: 300px;height: 300px;">
				<div fxFlex="100" style="margin:6px;font-size:12px;">
					<mat-label><span translate>項目</span></mat-label>
					<mat-radio-group (change)="onSort()" [(ngModel)]="sortCategory" class="radio-group" name="sortCategory">
						<mat-radio-button class="radio-button" value="name"><span translate>名前</span></mat-radio-button>
						<mat-radio-button class="radio-button" value="score"><span translate>点数</span></mat-radio-button>
						<mat-radio-button class="radio-button" value="club"><span translate>クラブ種類</span></mat-radio-button>
						<mat-radio-button class="radio-button" value="create"><span translate>スイング日時</span></mat-radio-button>
					</mat-radio-group>
					<mat-label><span translate>並び順</span></mat-label>
					<mat-radio-group (change)="onSort()" [(ngModel)]="sortDirection" class="radio-group" name="sortDirection">
						<mat-radio-button class="radio-button" value="desc"><span translate>降順</span></mat-radio-button>
						<mat-radio-button class="radio-button" value="asc"><span translate>昇順</span></mat-radio-button>
					</mat-radio-group>
				</div>
			</mat-card>
			<div (click)="onSorterSlide()" matRipple style="background-color: #ff9200;border-top-right-radius: 16px;border-bottom-right-radius: 16px;">
				<button mat-icon-button style="width:20px;" id="mat-sort-button">
					<mat-icon style="font-size:16px;color: #f0f0f0;">sort</mat-icon>
					<div style="color:#f0f0f0;font-size:12px;font-weight:900;transform: rotate(90deg)">Sort...</div>
				</button>
			</div>
		</div>

		<div [@finder_slide]="finder_slide_position" fxLayout="row" style="position: absolute;top:320px;z-index:-1; backdrop-filter: blur(12px);">
			<mat-card style="width: 300px;">
				<div fxFlex="90">
					<div fxLayout="column">

						<mat-form-field fxFlex="50" style="font-size: 12px;">
							<mat-label><span translate>名前</span></mat-label>
							<input (change)="onFind()" [(ngModel)]="data.nickname" autocomplete="off" matInput name="nickname" placeholder="..." type="text">
						</mat-form-field>
						<div fxLayout="column">

							<mat-form-field appearance="fill" color="primary">
								<mat-label><span translate>日(From)</span></mat-label>
								<input (dateChange)="onFind()" (dateInput)="onFind()" [(ngModel)]="data.create.from" [matDatepicker]="from" matInput>
								<mat-datepicker-toggle [for]="from" matSuffix></mat-datepicker-toggle>
								<mat-datepicker #from></mat-datepicker>
							</mat-form-field>

							<mat-form-field appearance="fill" color="primary">
								<mat-label><span translate>日(To)</span></mat-label>
								<input (dateChange)="onFind()" (dateInput)="onFind()" [(ngModel)]="data.create.to" [matDatepicker]="to" matInput>
								<mat-datepicker-toggle [for]="to" matSuffix></mat-datepicker-toggle>
								<mat-datepicker #to></mat-datepicker>
							</mat-form-field>

						</div>
						<div fxLayout="row">

							<mat-form-field fxFlex="50" style="font-size: 12px;">
								<mat-label><span translate>点数(From)</span></mat-label>
								<input (change)="onFind()" [(ngModel)]="data.score.from" matInput max="100" min="0" name="score_from" type="number">
							</mat-form-field>
							<mat-form-field fxFlex="50" style="font-size: 12px;">
								<mat-label><span translate>点数(To)</span></mat-label>
								<input (change)="onFind()" [(ngModel)]="data.score.to" matInput max="100" min="0" name="score_to" type="number">
								<button (click)="data.score.from=0;data.score.to=0;onFind();" aria-label="Clear" mat-button mat-icon-button matSuffix id="mat-close-button">
									<mat-icon>close</mat-icon>
								</button>
							</mat-form-field>

						</div>
						<div fxLayout="row">
							<div fxFlex="33" style="font-size: 12px;">
								<mat-label><span translate>性別</span></mat-label>
								<mat-radio-group (change)="onFind()" [(ngModel)]="data.gender" class="radio-group" name="gender">
									<mat-radio-button class="radio-button" value="0"><span translate>すべて</span></mat-radio-button>
									<mat-radio-button class="radio-button" value="1"><span translate>男性</span></mat-radio-button>
									<mat-radio-button class="radio-button" value="2"><span translate>女性</span></mat-radio-button>
								</mat-radio-group>
							</div>
							<div fxFlex="33" style="font-size: 12px;">
								<mat-label><span translate>クラブ種類</span></mat-label>
								<mat-select (selectionChange)="onFind()" [(value)]="data.club" class="select-group">
									<mat-option *ngFor="let club of clubs" [value]="club.value">
										{{club.name}}
									</mat-option>
								</mat-select>
							</div>
							<div fxFlex="33" style="font-size: 12px;">
								<mat-label><span translate>お気に入り</span></mat-label>
								<mat-radio-group (change)="onFind()" [(ngModel)]="data.like" class="radio-group" name="like">
									<mat-radio-button class="radio-button" value="0"><span translate>すべて</span></mat-radio-button>
									<mat-radio-button class="radio-button" value="1"><span translate>はい</span></mat-radio-button>
									<mat-radio-button class="radio-button" value="2"><span translate>いいえ</span></mat-radio-button>
								</mat-radio-group>
							</div>
						</div>
					</div>
				</div>
			</mat-card>
			<div (click)="onFinderSlide()" matRipple style="background-color: #FF4800;border-top-right-radius: 16px;border-bottom-right-radius: 16px;">
				<button mat-icon-button style="width:20px;" id="mat-find-button">
					<mat-icon style="font-size:16px;color: #f0f0f0;">find_replace</mat-icon>
					<div style="color:#f0f0f0;font-size:12px;font-weight:900;transform: rotate(90deg)">Find...</div>
				</button>
			</div>
		</div>

	</mat-card>
</ng-container>
